export function copyMapAndDelete<
  K extends PropertyKey,
  M extends Map<K, unknown>
>(map: M, key: K): M {
  const nMap = new Map(map) as M;
  nMap.delete(key);
  return nMap;
}
